import React, { Component } from 'react'
import "../css file/fourthsection.css"
import { AiOutlineClockCircle } from "react-icons/ai"
export default class NavbarSecondSection extends Component {
    render() {
        return (
            <>
                <div className="slider-main-menu-main">
                    <div className="slider-main-menu">
                        <div className="navbar-second-section-sub-container">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">राष्ट्रिय पुरस्कार सम्बन्धि सूचना २०७८-</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>28th Nov 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">महाकवि लक्ष्मी प्रसाद देवकोटा पुरस्कार सम्बन्धी सूचना</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>26th Nov 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">साझेदारी अनुगमनको नमूना ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>22nd Oct 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">अमूर्त साँस्कृतिक सम्पदा दिवसको अवसरमा माननीय मन्त्रीज्यूको शुभकामना सन्देश ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>17th Oct 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">अमूर्त साँस्कृतिक सम्पदा दिवसको अवसरमा श्रीमान सचिवज्यूको शुभकामना सन्देश ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>17th Oct 17</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">छानविन समिति गठन गरिएको सम्बन्धी प्रेस विज्ञप्ति ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>29th Sep 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">हवाई भाडा छानविन समितिद्वारा श्रीमान् सचिवज्यू समक्ष प्रतिवेदन प्रस्तुत ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>1st Sep 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">नेपाल पर्यटन तथ्यांक, २०२० (Nepal Tourism Statistics, 2020) सार्वजनिक गरिएको सम्बन्धी प्रेस विज्ञप्ति ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>3rd Aug 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">NEPAL TOURISM STATISTICS 2020</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>3rd Aug 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">श्रीमान् सचिवज्यू एवं विभागीय प्रमुखहरुबीच आ.व. २०७८।७९ कार्यसम्पादन करार सम्झौता सम्पन्न ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>16th Jul 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">पुरातात्विक महत्वका मूर्तिहरु अमेरिकाबाट फिर्ता गरी नेपाल ल्याइएको सम्बन्धी प्रेस विज्ञप्ति ।</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>15th Jul 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">Hotel Standard 2077</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>30th Jun 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">नेपाल सरकार र बंगलादेश सरकारबीच पर्यटन क्षेत्रमा सहयोग आदान प्रदान गर्ने उद्श्यले बंगलादेश सरकारसंग MOU सम्म्पन |</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>26th Mar 21</p>
                            </div>
                        </div>
                        <div className="navbar-second-section-sub-container ">
                            <div className="navbar-second-section1">
                                < a href="/">Notice: </a>
                            </div>
                            <div className="navbar-second-section2 navbar-second-section-p-flex">
                                < a href="/">Nepal Homestay Contact Directory- BY Taragoon</a>
                            </div>
                            <div className="navbar-second-section3">
                                <AiOutlineClockCircle className="navbar-second-section-p-icon" />
                                <p>23rd Mar 21</p>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        )
    }

}
